module.exports = __webpack_public_path__ + "static/media/Group_1597880791@2x.d30a2199.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_210/images/Group_1597880791@2x.png
// module id = 1746
// module chunks = 0